import { useMemo } from 'react'

import styles from './FileCard.module.less'


const splitFileName = (filename: string) => {
  const lastDotIndex = filename.lastIndexOf('.')
  if (lastDotIndex === -1) return { base: filename, ext: '' }
  return {
    base: filename.substring(0, lastDotIndex),
    ext: filename.substring(lastDotIndex),
  }
}
const FILE_TYPE_CONFIG: Record<string, { color: string; label?: string }> = {
  pdf: { color: '#FD7E14' }, // 橙红色
  xls: { color: '#3BB25A' }, // 绿色
  xlsx: { color: '#3BB25A' },
  doc: { color: '#3363FF' }, // 蓝色
  docx: { color: '#3363FF' },
  txt: { color: '#3363FF' },
  // 默认兜底颜色
  default: { color: '#999999' },
}

// --- 子组件：通用文件盒子 ---
export const GenericFileCard = ({
  name,
  size,
  type,
  status
}: {
  name: string
  size: string
  type: string
  status?: string
}) => {
  const { base, ext } = useMemo(() => splitFileName(name), [name])

  // 1. 获取后缀名（不带点，转小写）
  const extension = ext.replace('.', '').toLowerCase()

  // 2. 获取头像文字：优先用后缀，没有就用文件名首字母
  const avatarText = (extension || base || '?').charAt(0).toUpperCase()

  // 3. 根据后缀获取背景颜色
  const bgColor = useMemo(() => {
    // 匹配配置表中的颜色，找不到则用默认颜色
    return (FILE_TYPE_CONFIG[extension] || FILE_TYPE_CONFIG.default).color
  }, [extension])

  return (
    <div className={styles.fileBox}>
      <div className={styles.avatar} style={{ backgroundColor: bgColor }}>
        {avatarText}
      </div>
      <div className={styles.fileInfo}>
        <div className={styles.nameContainer}>
          <span className={styles.baseName}>{base}</span>
          <span className={styles.extName}>{ext}</span>
        </div>
        <div className={styles.size}>{status === 'uploading' ? '上传中' : status === 'error' ? '上传失败' : size}</div>
      </div>
    </div>
  )
}
